<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <img class="logo" src="../assets/images/app-logo.svg" />
    </ion-item>
  </ion-toolbar>
</ion-header>

<ion-content full>
  <ion-grid class="box auth__outher-container">
    <ion-row justify-content-center class="auth__container">
      <ion-col>
        <!-- <app-language></app-language> -->
        <div class="ion-text">
          <h1 class="auth__header">
            {{ 'AUTH.LOGIN' | translate }}
            <span>
              <ng-container
                *ngFor="let langButton of languageList; let i = index "
              >
                <ion-button
                  *ngIf="languageList[i] !== currentLang"
                  (click)="changeLanguage(langButton)"
                  fill="clear"
                  size="small"
                >
                  <ion-icon
                    slot="icon-only"
                    src="assets/icons/lang.{{languageList[i]}}.svg"
                  ></ion-icon>
                </ion-button>
              </ng-container>
            </span>
          </h1>
        </div>

        <ion-item *ngIf="unautorized" lines="none">
          <ion-label color="danger" class="font-size__16"> {{ errorMessage | translate }} </ion-label>
        </ion-item>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <app-input
            (keyup.enter)="onSubmit()"
            type="input"
            [form]="loginForm"
            formControlName="email"
            label="AUTH.EMAIL"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            (keyup.enter)="onSubmit()"
            [type]="passwordEye ? 'text' : 'password'"
            [form]="loginForm"
            formControlName="password"
            label="AUTH.PASSWORD"
            [showPasswordEye]="true"
            [(passwordEye)]="passwordEye"
            [submittedError]="validationError"
          ></app-input>

          <app-input
            (keyup.enter)="onSubmit()"
            type="input"
            [form]="loginForm"
            formControlName="appname"
            label="AUTH.LOCATION"
            [submittedError]="validationError"
          ></app-input>

          <app-checkbox
            [slot]="'start'"
            [form]="loginForm"
            formControlName="rememberMe"
            label="AUTH.REMEMBER_ME"
          ></app-checkbox>

          <ion-button
            [disabled]="loading"
            class="auth__login-button"
            (click)="onSubmit()"
            size="large"
            expand="block"
          >
            <app-loading-sti *ngIf="loading"></app-loading-sti>
            {{ 'AUTH.LOGIN2' | translate }}
          </ion-button>
        </form>

        <div class="ion-text-center auth__forgot-password-button">
          <a class="primary" routerLink="/auth/forgot-password"
            >{{'AUTH.FORGOT_PASSWORD' | translate}}</a
          >
          <br />
        </div>
      </ion-col>
    </ion-row>
    <ion-row justify-content-center class="auth__second-container">
      <ion-col>
        <ion-button
          type="outline"
          routerLink="/auth/register"
          size="large"
          expand="block"
        >
          {{'AUTH.CREATE_ACCOUNT' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
